import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import {
    AnchorPageRelayQuery,
    shapeAnchorContentfulResponse
} from "src/contentful/graphql/anchor-page";

import { anchorPageRelayQuery } from "@/__generated_contentful__/anchorPageRelayQuery.graphql";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";

// @ts-ignore
import { JiraSoftwarePageProps } from "./jira-software-page";
import { JiraSoftwarePagePaidLpJswAnchor } from "./paid-lp-jsw-anchor";

export interface JiraSoftwarePagePaidLpJswTrackerRelayProps
    // @ts-ignore
    extends JiraSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
    queryRef?: PreloadedQuery<anchorPageRelayQuery>;
}

export const JiraSoftwarePagePaidLpJswTracker = (
    pageProps: JiraSoftwarePagePaidLpJswTrackerRelayProps
) => {
    const data = usePreloadedQuery(
        AnchorPageRelayQuery,
        pageProps.queryRef ||
            (null as unknown as PreloadedQuery<anchorPageRelayQuery>)
    );

    return (
        <JiraSoftwarePagePaidLpJswAnchor
            {...pageProps}
            anchorContents={shapeAnchorContentfulResponse(data)}
            pageId="paid-lp-jsw-tracker"
            persona="unknown"
            pageVariant="tracker"
        />
    );
};
